import BasicRecord from "../utils/BasicRecord";
import StyleguideLevel from "./styleguideLevel";
import StyleguideNode from "./styleguideNode";

/**
 * Returns an object with level keys and values of child nodes at corresponding level
 */
function getLevels(parentNode: StyleguideNode, depth = 1, levels: BasicRecord<StyleguideNode[]> = {}):
    StyleguideLevel[] {
    if (parentNode.children.length > 0) {
        levels[depth] = (levels[depth] ?? []).concat(parentNode.children);
        parentNode.children.forEach(child => getLevels(child, depth + 1, levels));
    }

    return Object.keys(levels).map(key => new StyleguideLevel(Number(key), levels[key]));
}

export default class StyleguideTree {
    root: StyleguideNode;
    levels: StyleguideLevel[];

    constructor(root: StyleguideNode) {
        this.root = root;
        this.levels = getLevels(root);
    }

    get height(): number {
        return Object.keys(this.levels).length + 1;
    }

    get length(): number {
        return 1 + this.levels.reduce((acc, curr) => acc + curr.nodes.length, 0);
    }

    isRootTree(): boolean {
        return this.root.isLeaf();
    }

    isArchived(): boolean {
        return this.root.isArchived();
    }

    getNodesAtLevel(index: number): StyleguideNode[] {
        return this.levels[index].nodes;
    }
}
